import { badgeDefaultStyle, badgeContainerStyle } from './badgeDefaultStyle';
import badgeStyleDecorator from './badgeStyleDecorator';
import { iconStartStyleDecorator, iconEndStyleDecorator } from './iconStyleDecorator';
const badgeStyleBuilder = (theme, variant) => {
  let style = badgeDefaultStyle(theme);
  style = badgeStyleDecorator(variant, style, theme);
  return style;
};
const badgeContainerStyleBuilder = theme => {
  const style = badgeContainerStyle(theme);
  return style;
};
const iconStartBadgeStyleBuilder = (variant, theme) => {
  return iconStartStyleDecorator(variant, theme);
};
const iconEndBadgeStyleBuilder = (variant, theme) => {
  return iconEndStyleDecorator(variant, theme);
};
export { badgeStyleBuilder, badgeContainerStyleBuilder, iconStartBadgeStyleBuilder, iconEndBadgeStyleBuilder };